import { createContext } from "react";

export const VerifyNameContext = createContext<(name: string) => boolean>(() => false)
